// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[class=\"accordion-button\"] .activated[data-v-ce3fefd2] {\n  color: #009ef7 !important;\n  background-color: #f5f8fa !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
